<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="标题名称">
          <el-input v-model="formInline.title" placeholder="标题名称"></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" @click="onSubmit">查询</el-button> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="onSubmit()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>

      <div class="text item text-center">
        <el-table :data="tableData1" style="width: 100%" max-height="560" border :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{padding: '7px 0', textAlign: 'center' }" @row-click="openDetails">
          <el-table-column prop="clevel" label="紧急程度" width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.clevel">
                <el-tag type="primary" v-if="scope.row.clevel=='普通'">{{scope.row.clevel}}</el-tag>
                <el-tag type="danger" size="small" v-if="scope.row.clevel=='紧急'" effect="dark">{{scope.row.clevel}}</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="cdec" label="标题" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ctitle" label="内容" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="clevel" label="紧急程度"></el-table-column> -->

          <el-table-column prop="ddate" label="时间" width="160"></el-table-column>

        </el-table>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formInline: {
        title: "",
      },
      notvisi: false,
      NoticeDel: {},
      tableData1: [
        {
          content: "报价单",
          title: "报价单",
        },
        {
          content: "待确认订单",
          title: "待确认订单",
        },
      ],
    };
  },
  created() {
    this.PruchaseToDo();
  },
  methods: {
    // 获取待办事项
    PruchaseToDo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetPruchaseToDo",
      }).then((res) => {
        console.log(res, "获取待办事项");
        if (res.data.Success) {
          this.tableData1 = res.data.Data;
          for (var a = 0; a < this.tableData1.length; a++) {
            if (this.tableData1.ddate != "") {
              this.tableData1[a].ddate =
                this.tableData1[a].ddate.substring(0, 10) +
                "  " +
                this.tableData1[a].ddate.substring(11, 19);
            }
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 待办事项的点击事件
    openDetails(row) {
      if (row.ctype == "X_05") {
        row.id = row.cid;
        this.$router.push({ name: "Rectification", params: { rows: row } });
      }
      if (row.ctype == "X_04") {
        row.id = row.cid;
        this.$router.push({ name: "AccountStatement", params: { rows: row } });
      }
      if (row.ctype == "X_03") {
        row.id = row.cid;
        this.$router.push({ name: "OnlineContract", params: { rows: row } });
      }
      if (row.ctype == "X_02") {
        row.id = row.cid;
        this.$router.push({ name: "OrderConfirm", params: { rows: row } });
      }
      if (row.ctype == "X_01") {
        row.id = row.cid;
        this.$router.push({ name: "SupInvoiceadd", params: { rows: row } });
      }
      if (row.ctype == "X_0102") {
        row.id = row.cid;
        this.$router.push({ name: "SupInvoiceaddcont", params: { rows: row } });
      }
      if (row.ctype == "X_0103") {
        row.id = row.cid;
        this.$router.push({ name: "SupInvoiceaddcom", params: { rows: row } });
      }
    },
    onSubmit() {
      console.log("submit!");
    },
    notvisiif(val) {
      this.notvisi = val;
    },
    read(val) {
      this.notvisi = true;
      this.NoticeDel = val;
    },
  },
};
</script>

